module.exports = {
  "FoodC_ServiceFee_LQae_RZIk": "Ingresa tu dirección",
  "FoodC_ServiceFee_EvAo_Aloo": "Dirección"
}